import FeeTypesEnum from '../../Enums/FeeTypesEnum';

export default class FreelancerFeeHelper {
  static GetFeeTypeIcon(feeType) {
    switch (feeType) {
      case FeeTypesEnum.Resource:
      case FeeTypesEnum.RM:
        return 'fa-regular fa-user-clock';
      case FeeTypesEnum.DataQuality:
      case FeeTypesEnum.DQ:
        return 'fa-solid fa-clipboard-check';
      case FeeTypesEnum.KAM:
        return 'fa-brands fa-keycdn';
      case FeeTypesEnum.BD:
        return 'fa-regular fa-handshake';
      case FeeTypesEnum.BI:
        return 'fa-regular fa-square-poll-vertical';
      case FeeTypesEnum.Finance:
        return 'fa-regular fa-calculator';
      case FeeTypesEnum.Marketing:
        return 'fa-regular fa-globe-pointer';
      case FeeTypesEnum.IT:
        return 'fa-solid fa-microchip';
      case FeeTypesEnum.HR:
        return 'fa-solid fa-people';
      case FeeTypesEnum.FieldworkPartner:
        return 'fa-solid fa-handshake';
      default:
        return 'fa-solid fa-notdef';
    }
  }
}
